import { ICustomBinding } from "#/DefaultViewExtensionInterfaces";

export default class ControlIdentBinding implements ICustomBinding {

    public initBinding() {
        ko.bindingHandlers.controlIdent = {
            init: (element: HTMLElement, valueAccessor: () => any) => {
                let ident = ko.unwrap(valueAccessor());

                $(element).attr('data-control', ident);
            }
        };
    }
}